/*
 * @Author: your name
 * @Date: 2021-09-22 14:25:36
 * @LastEditTime: 2022-02-17 15:54:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ruigu-launchpad-new/src/components/IndexContent/IndexContent.js
 */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
// import ModalItemContent from "@/components/ModalItemContent/ModalItemContent";
import IndexContentItem from "./IndexContentItem";
// styl
import "./IndexContent.styl";

class IndexContent extends Component {
  state = {
    menuList: [1508, 1509, 1553, 1554, 1566, 1567, 1573],
    modalInfo: {
      visible: false,
      menu: [],
      title: "",
    },
  };

  /**
   * @description 处理菜单点击事件。
   * @description 当菜单权限编码为禅道入口时执行禅道免登录跳转，其它菜单保持原有模块打开逻辑。
   * @param params 当前点击的菜单数据
   * @returns void
   */
  itmeClick = (params) => {
    this.props.onClickModule({
      ...params,
      id: String(params.id),
      path: params.type === 1 ? `${window.location.origin}/menuLayout` : params.path,
      backPath: params.type === 1 ? `${window.location.origin}/menuLayout` : params.backPath,
    });
  };

  render() {
    return (
      <div className="index-content m-0-a">
        {(this.props.menu || []).map((item) => {
          return (
            <div className="system-item" key={item.id}>
              <h2 className="system-title bold fs-18">{item.title}</h2>
              <IndexContentItem onItmeClick={this.itmeClick} item={item} />
            </div>
          );
        })}
      </div>
    );
  }
}

export default withRouter(IndexContent);
